import './App.css'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import WorkSpace from './components/WorkSpace.js'
import PdsSpinner from './components/PdsSpinner.js'
import Feedback from './components/Feedback.js'
import redux from './redux/index.js'
import socket from './redux/socket-io.js'
import { isValidToken } from './util.js'

const App = ({
  strings,
  idToken,
  token,
  error,
  onResetError,
  connectWebsockets,
  doLogin,
  doStartHeartBeat,
  handleWindowResize
}) => {
  const isLoggedIn = isValidToken(token)

  const renderError = () => {
    const errorMessage = () => {
      if (error) {
        console.error(error)
        const { errorType, errorMessage } = error
        const translatedErrorType = strings[errorType] || 'N/A'
        if (errorMessage) {
          const translatedErrorMessage = strings[errorMessage] || errorMessage
          return `${translatedErrorType} (${translatedErrorMessage})`
        } else {
          return translatedErrorType
        }
      } else {
        return ''
      }
    }
    return (
      <Feedback
        open={!!error}
        message={errorMessage()}
        variant='error'
        closeTimeout={10000}
        onAutoClose={onResetError}
      />
    )
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)
    window.dispatchEvent(new Event('resize')) // eslint-disable-line

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  // Start heartbeat on initial render.
  useEffect(doStartHeartBeat, [])

  // Reconnect on websockets if token changes.
  useEffect(() => {
    if (isLoggedIn) {
      connectWebsockets(token)
    }
  }, [token])

  // Auto login if not logged in.
  useEffect(() => {
    if (!isLoggedIn) {
      setTimeout(() => doLogin(idToken), 200)
    }
  }, [isLoggedIn])

  // TODO add showNoAccountPage functionality from add-in

  return (
    <>
      {renderError()}
      {isLoggedIn ? <WorkSpace /> : <Spinner />}
    </>
  )
}

const Spinner = () => {
  return (
    <div style={alignSpinnerStyle}>
      <PdsSpinner />
    </div>
  )
}

const alignSpinnerStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

const mapStateToProps = (state) => {
  const { token } = state.login.userData
  return {
    strings: state.locale.strings,
    token,
    error: state.error
  }
}

const mapDispatchToProps = (dispatch) => {
  const { resetError } = redux.actions.error
  return {
    onResetError: () => {
      dispatch(resetError())
    },
    connectWebsockets: (token) => {
      socket.connect(token, dispatch)
    },
    doLogin: (idToken) => {
      dispatch(redux.actions.login.doLogin(idToken))
    },
    doStartHeartBeat: () => {
      dispatch(redux.actions.login.doStartHeartBeat())
    },
    handleWindowResize: () => {
      dispatch(redux.actions.window.setWindowWidth(window.innerWidth))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
